// @flow
import React from 'react';
import WarningText from '../WarningText/WarningText';
import './CustomerFileList.css';
import FormattedDate from '../FormattedDate/FormattedDate';
import _ from 'lodash/fp';
import {apiBase} from '../../helpers/request';

const fileUrl = `${apiBase}/files`;

const generateArchived = (label, oldItems) => {
  return !!(oldItems && !!oldItems.length) && (
    <div>
      <label>
        Arkiverade {label}
      </label>
      <div className="file-list">
        {_.map(f =>
          <a
            href={`${fileUrl}/${f.id}?download`}
            target="_blank"
            key={f.id}
            className="item text-truncate">
            <FormattedDate
              className="item-date"
              value={f.archived} />
            <span className="item-name">{f.name}</span>
          </a>
          , oldItems)}
      </div>
    </div>
  );
};

const generateList = (singleLabel, multiLabel, currentItem, oldItems) => {
  return (
    <div className="CustomerFileList">
      <label className="headlabel">
        {singleLabel}
      </label>
      <div className="file-list">
        {(!currentItem &&
          <div className="empty-item">
            {singleLabel} saknas
          </div>) ||
        <a
          href={`${fileUrl}/${currentItem.id}?download`}
          target="_blank"
          key={currentItem.id}
          className="item text-truncate">
          <span className="item-name">{currentItem.name}</span>
        </a>
        }
      </div>
      {generateArchived(multiLabel, oldItems)}
    </div>
  );
};

export type Props = {
  apartment: any,
};

const CustomerFileList = ({apartment}: Props) => {
  return (
    <div>
      <div className="page-header">
        <div className="page-title">
          Filer för lägenhet {apartment.objectId}
        </div>
      </div>
      { generateList('Beställningsunderlag', 'Beställningsunderlag', apartment.contract, apartment.oldContracts) }
      { generateList('Planritning', 'Planritningar', apartment.floorPlan, apartment.oldFloorPlans) }
      { generateList('Köksritning', 'Köksritningar', apartment.kitchenPlan, apartment.oldKitchenPlans) }
      <WarningText />
    </div>
  );
};

export default CustomerFileList;



// WEBPACK FOOTER //
// ./src/components/CustomerFileList/CustomerFileList.js